import { render } from "./App.vue?vue&type=template&id=d2af4e1c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d2af4e1c&lang=css"
script.render = render

export default script